// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9aacbb77","239":"6fe9f988","455":"542f0c30"}[chunkId] + ".chunk.js";
};